import {
  RUN_STAGE_MONITOR_REQUEST,
  RUN_STAGE_MONITOR_SUCCESS,
  RUN_STAGE_MONITOR_FAILURE,
  CLEAR_MONITOR_DATA,

  RUN_RISKCARD_MONITOR_REQUEST,
  RUN_RISKCARD_MONITOR_SUCCESS,
  RUN_RISKCARD_MONITOR_FAILURE,
  CLEAR_RISKCARD_MONITOR,

  RUN_SCENARIO_MONITOR_REQUEST,
  RUN_SCENARIO_MONITOR_SUCCESS,
  RUN_SCENARIO_MONITOR_FAILURE,
  CLEAR_SCENARIO_MONITOR,
} from '../actions/actionTypes';

const initialState = {
  stage: {},      // stage[modelId] = { loading, data, error }
  riskCard: {},   // riskCard[modelId] = { loading, data, error }
  scenario: {}    // scenario[modelId] = { loading, data, error }
};

export default function monitors(state = initialState, action) {
  switch (action.type) {

    // -- STAGE MONITOR -------------------------------------------------------

    case RUN_STAGE_MONITOR_REQUEST: {
      const { modelId } = action.payload;
      return {
        ...state,
        stage: {
          ...state.stage,
          [modelId]: { loading: true,  data: null,        error: null }
        }
      };
    }
    case RUN_STAGE_MONITOR_SUCCESS: {
      const { modelId, revision, entries, fromStage, toStage } = action.payload;
      return {
        ...state,
        stage: {
          ...state.stage,
          [modelId]: { loading: false, data: { revision, entries, fromStage, toStage }, error: null }
        }
      };
    }
    case RUN_STAGE_MONITOR_FAILURE: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        stage: {
          ...state.stage,
          [modelId]: { loading: false, data: null, error }
        }
      };
    }
    case CLEAR_MONITOR_DATA: {
      const { modelId } = action.payload;
      const next = { ...state.stage };
      delete next[modelId];
      return { ...state, stage: next };
    }

    // -- RISK CARD MONITOR --------------------------------------------------

    case RUN_RISKCARD_MONITOR_REQUEST: {
      const { modelId } = action.payload;
      return {
        ...state,
        riskCard: {
          ...state.riskCard,
          [modelId]: { loading: true,  data: null,       error: null }
        }
      };
    }
    case RUN_RISKCARD_MONITOR_SUCCESS: {
      const { modelId, revision, diffSummary, diffDetails, entries } = action.payload;
      return {
        ...state,
        riskCard: {
          ...state.riskCard,
          [modelId]: { loading: false, data: { revision, diffSummary, diffDetails, entries }, error: null }
        }
      };
    }
    case RUN_RISKCARD_MONITOR_FAILURE: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        riskCard: {
          ...state.riskCard,
          [modelId]: { loading: false, data: null, error }
        }
      };
    }
    case CLEAR_RISKCARD_MONITOR: {
      const { modelId } = action.payload;
      const next = { ...state.riskCard };
      delete next[modelId];
      return { ...state, riskCard: next };
    }

    // -- SCENARIO MONITOR ---------------------------------------------------

    case RUN_SCENARIO_MONITOR_REQUEST: {
      const { modelId } = action.payload;
      return {
        ...state,
        scenario: {
          ...state.scenario,
          [modelId]: { loading: true,  data: null,       error: null }
        }
      };
    }
    case RUN_SCENARIO_MONITOR_SUCCESS: {
      const { modelId, section, report } = action.payload;
      return {
        ...state,
        scenario: {
          ...state.scenario,
          [modelId]: { loading: false, data: { section, report }, error: null }
        }
      };
    }
    case RUN_SCENARIO_MONITOR_FAILURE: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        scenario: {
          ...state.scenario,
          [modelId]: { loading: false, data: null, error }
        }
      };
    }
    case CLEAR_SCENARIO_MONITOR: {
      const { modelId } = action.payload;
      const next = { ...state.scenario };
      delete next[modelId];
      return { ...state, scenario: next };
    }

    default:
      return state;
  }
}

// import {
//     RUN_STAGE_MONITOR_REQUEST,
//     RUN_STAGE_MONITOR_SUCCESS,
//     RUN_STAGE_MONITOR_FAILURE,
//     CLEAR_MONITOR_DATA,
//     RUN_RISKCARD_MONITOR_REQUEST,
//     RUN_RISKCARD_MONITOR_SUCCESS,
//     RUN_RISKCARD_MONITOR_FAILURE,
//     CLEAR_RISKCARD_MONITOR,
//     RUN_SCENARIO_MONITOR_REQUEST,
//     RUN_SCENARIO_MONITOR_SUCCESS,
//     RUN_SCENARIO_MONITOR_FAILURE,
//     CLEAR_SCENARIO_MONITOR,
//   } from '../actions/actionTypes';
  
//   const initialState = {};
  
//   /**
//    * monitors[stateKey = modelId] = {
//    *   loading: boolean,
//    *   data: { revision, entries, fromStage, toStage } | null,
//    *   error: string | null
//    * }
//    */
//   export default function monitors(state = initialState, action) {
//     switch (action.type) {
//       case RUN_STAGE_MONITOR_REQUEST: {
//         const { modelId } = action.payload;
//         return {
//           ...state,
//           [modelId]: { loading: true, data: null, error: null }
//         };
//       }
//       case RUN_STAGE_MONITOR_SUCCESS: {
//         const { modelId, revision, entries, fromStage, toStage } = action.payload;
//         return {
//           ...state,
//           [modelId]: {
//             loading: false,
//             data: { revision, entries, fromStage, toStage },
//             error: null
//           }
//         };
//       }
//       case RUN_STAGE_MONITOR_FAILURE: {
//         const { modelId, error } = action.payload;
//         return {
//           ...state,
//           [modelId]: { loading: false, data: null, error }
//         };
//       }

//       case CLEAR_MONITOR_DATA: {
//               const { modelId } = action.payload;
//               const next = { ...state };
//               delete next[modelId];
//               return next;
//             }

//             case RUN_RISKCARD_MONITOR_REQUEST: {
//               const { modelId } = action.payload;
//               return { ...state, [modelId]: { loading: true, data: null, error: null } };
//             }
//             case RUN_RISKCARD_MONITOR_SUCCESS: {
//               const { modelId, revision, diffSummary } = action.payload;
//               return {
//                 ...state,
//                 [modelId]: { loading: false, data: { revision, diffSummary }, error: null },
//               };
//             }
//             case RUN_RISKCARD_MONITOR_FAILURE: {
//               const { modelId, error } = action.payload;
//               return { ...state, [modelId]: { loading: false, data: null, error } };
//             }
//             case CLEAR_RISKCARD_MONITOR: {
//               const { modelId } = action.payload;
//               const next = { ...state };
//               delete next[modelId];
//               return next;
//             }
//             case RUN_SCENARIO_MONITOR_REQUEST: {
//       const { modelId } = action.payload;
//       return { 
//         ...state, 
//         [modelId]: { loading:true, data:null, error:null } 
//       };
//     }
//     case RUN_SCENARIO_MONITOR_SUCCESS: {
//       const { modelId, section, report } = action.payload;
//       return {
//         ...state,
//         [modelId]: {
//           loading: false,
//           data: { section, report },
//           error: null
//         }
//       };
//     }
//     case RUN_SCENARIO_MONITOR_FAILURE: {
//       const { modelId, error } = action.payload;
//       return {
//         ...state,
//         [modelId]: { loading:false, data:null, error }
//       };
//     }
//     case CLEAR_SCENARIO_MONITOR: {
//       const { modelId } = action.payload;
//       const next = { ...state };
//       delete next[modelId];
//       return next;
//     }
//       default:
//         return state;
//     }
//   }